<!--
 * @Author: zhaoliang
 * @Date: 2024-05-10 15:15:16
 * @LastEditTime: 2026-01-22 14:36:13
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/LoungePrebook/SelectDate/index.vue
 *
-->
<template>
  <div class="select-container">
    <DatePicker
      value-type="YYYY-MM-DD"
      :append-to-body="false"
      :disabled-date="disabledDate"
      @change="handleChange"
      :value="value"
      :clearable="false"
    >
      <template #input>
        <div class="select-wrapper" :class="{ error: errorStatus }">
          <div class="select-content" v-if="value">{{ formatValue }}</div>
          <div class="select-content-placeholder" v-else>
            {{ $t('prebook-step1-date-placeholder') }}
          </div>
          <div class="select-icon">
            <img src="~img/icon-date.svg" />
          </div>
        </div>
      </template>
      <template #icon-calendar>
        <div></div>
      </template>
    </DatePicker>
  </div>
</template>
<script>
  import DatePicker from 'vue-datepicker-next';
  import 'vue-datepicker-next/index.css';
  import dayjs from 'dayjs';
  import enLngObject from 'dayjs/locale/en';
  import frLngObject from 'dayjs/locale/fr-ca';
  export default {
    components: {
      DatePicker,
    },
    props: {
      value: {
        type: String,
        default: '',
      },
      disabledDate: {
        type: Function,
        default: () => {},
      },
      errorStatus: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {};
    },
    methods: {
      handleChange(date) {
        this.$emit('onChange', date);
      },
    },
    mounted() {
      // 注册en以及fr语言, en使用默认配置, fr针对月份简写使用自定义配置
      dayjs.locale('en_US', enLngObject);
      dayjs.locale('fr_CA', {
        ...frLngObject,
        monthsShort: [
          'Jan',
          'Fév',
          'Mar',
          'Avr',
          'Mai',
          'Jun',
          'Jul',
          'Aoû',
          'Sep',
          'Oct',
          'Nov',
          'Déc',
        ],
      });
    },
    computed: {
      formatValue() {
        return this.value ? dayjs(this.value).locale(this.$i18n.locale).format('DD MMM YYYY') : '';
      },
    },
    directives: {},
  };
</script>
<style lang="scss" scoped>
  .select-container {
    width: 100%;

    .select-wrapper {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid #9eacb5;
      padding: 20px;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &.error {
        border-color: #cc2222;
      }

      .select-content,
      .select-content-placeholder {
        @include font($size: 20px, $weight: 600);
      }

      .select-content-placeholder {
        color: #7f898f;
      }

      .select-icon {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.3s;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    .select-container {
      .select-wrapper {
        padding: 10px 10px;

        .select-content,
        .select-content-placeholder {
          @include font($size: 16px, $weight: 600);
        }

        .select-content-placeholder {
          color: #7f898f;
        }

        .select-icon {
          width: 18px;
          height: 18px;

          img {
            width: 18px;
            height: 18px;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .mx-datepicker {
    width: 100%;
  }

  .mx-datepicker-main {
    font-family: 'Open Sans', sans-serif !important;
  }

  .mx-datepicker-popup {
    border-radius: 8px;

    .mx-datepicker-content {
      .mx-datepicker-body {
        .mx-calendar {
          /* prettier-ignore */
          width: 324Px;

          .mx-calendar-header {
            .mx-calendar-header-label {
              .mx-btn {
                font-family: 'Open Sans', sans-serif !important;
                font-weight: 700;
              }
            }
          }
          .mx-calendar-content {
            /* prettier-ignore */
            height: 300Px;

            .mx-table {
              .mx-date-row {
                .not-current-month {
                  color: unset;
                }

                .active {
                  border-radius: 50%;
                  background-color: #163049 !important;
                }

                .today {
                  border-radius: 50%;
                  background-color: #e7eaed !important;
                  color: #73879c;
                }

                .disabled {
                  color: #ccc;
                  background-color: unset;
                }

                .cell:hover {
                  color: #ffffff;
                  border-radius: 50%;
                  background-color: #163049 !important;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
